export default "__VITE_ASSET__8HPX0R61__"